(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function updateFooterClock() {
    var hourHand = document.querySelector('[data-clock-hour]');
    var minuteHand = document.querySelector('[data-clock-minute]');
    var secondHand = document.querySelector('[data-clock-second]');
    if (!hourHand || !minuteHand || !secondHand) return;

    var now = new Date();
    var h = now.getHours() % 12;
    var m = now.getMinutes();
    var s = now.getSeconds();

    var hDeg = (h + m / 60) * 30;
    var mDeg = (m + s / 60) * 6;
    var sDeg = s * 6;

    hourHand.style.transform = 'rotate(' + hDeg + 'deg)';
    minuteHand.style.transform = 'rotate(' + mDeg + 'deg)';
    secondHand.style.transform = 'rotate(' + sDeg + 'deg)';
  }

  updateFooterClock();
  setInterval(updateFooterClock, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var header = document.querySelector('[data-site-header]');
  if (!header) return;

  /* ---------------- Announcement bar dismiss ---------------- */
  var announceBar = document.querySelector('[data-announce-bar]');
  var announceClose = document.querySelector('[data-announce-close]');
  var ANNOUNCE_KEY = 'header-announce-dismissed';

  if (announceBar && announceClose) {
    try {
      if (sessionStorage.getItem(ANNOUNCE_KEY) === '1') {
        announceBar.style.display = 'none';
      }
    } catch (e) {}

    announceClose.addEventListener('click', function () {
      announceBar.style.display = 'none';
      try {
        sessionStorage.setItem(ANNOUNCE_KEY, '1');
      } catch (e) {}
    });
  }

  /* ---------------- Mobile drawer ---------------- */
  var drawer = document.querySelector('[data-drawer]');
  var drawerOpenBtns = document.querySelectorAll('[data-drawer-open]');
  var drawerCloseEls = document.querySelectorAll('[data-drawer-close]');

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawerOpenBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    drawerOpenBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  if (drawer) {
    drawerOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    drawerCloseEls.forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // nested submenu accordions
    var submenuToggles = drawer.querySelectorAll('[data-submenu-toggle]');
    submenuToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('.mobile-drawer__item');
        var isOpen = item.classList.contains('is-open');
        drawer.querySelectorAll('.mobile-drawer__item.is-open').forEach(function (el) {
          if (el !== item) el.classList.remove('is-open');
        });
        item.classList.toggle('is-open', !isOpen);
      });
    });
  }

  /* ---------------- Search panel + predictive search ---------------- */
  var searchOpenBtn = document.querySelector('[data-search-open]');
  var searchCloseBtn = document.querySelector('[data-search-close]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchDebounce;

  function openSearch() {
    searchPanel.hidden = false;
    requestAnimationFrame(function () {
      searchPanel.classList.add('is-open');
    });
    searchOpenBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () {
      searchInput.focus();
    }, 150);
  }

  function closeSearch() {
    searchPanel.classList.remove('is-open');
    searchOpenBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      searchPanel.hidden = true;
    }, 250);
  }

  if (searchOpenBtn && searchPanel) {
    searchOpenBtn.addEventListener('click', function () {
      var isOpen = searchPanel.classList.contains('is-open');
      isOpen ? closeSearch() : openSearch();
    });
    searchCloseBtn.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });

    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(searchDebounce);

      if (term.length < 2) {
        searchResults.innerHTML = '';
        return;
      }

      searchDebounce = setTimeout(function () {
        fetchPredictiveResults(term);
      }, 250);
    });
  }

  function fetchPredictiveResults(term) {
    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        renderResults(data && data.resources && data.resources.results ? data.resources.results.products : []);
      })
      .catch(function () {
        searchResults.innerHTML = '';
      });
  }

  function renderResults(products) {
    if (!products || !products.length) {
      searchResults.innerHTML = '<div class="search-panel__empty">No matches found</div>';
      return;
    }

    var html = products
      .map(function (p) {
        var img = p.featured_image ? p.featured_image.url : '';
        var price = p.price ? formatMoney(p.price) : '';
        return (
          '<a class="search-result" href="' + p.url + '">' +
            (img ? '<img src="' + img + '" alt="" width="40" height="40" loading="lazy">' : '') +
            '<span class="search-result__meta">' +
              '<span class="search-result__title">' + escapeHtml(p.title) + '</span>' +
              (price ? '<span class="search-result__price">' + price + '</span>' : '') +
            '</span>' +
          '</a>'
        );
      })
      .join('');

    searchResults.innerHTML = html;
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  /* ---------------- Slide-out cart drawer ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  var cartCloseEls = cartDrawer ? cartDrawer.querySelectorAll('[data-cart-close]') : [];
  var cartItemsEl = document.querySelector('[data-cart-items]');
  var cartEmptyEl = document.querySelector('[data-cart-empty]');
  var cartFooterEl = document.querySelector('[data-cart-footer]');
  var cartSubtotalEl = document.querySelector('[data-cart-subtotal]');
  var cartDrawerCountEl = document.querySelector('[data-cart-drawer-count]');

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    cartOpenBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    cartOpenBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  if (cartDrawer) {
    cartOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });
    cartCloseEls.forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
  }

  function renderCartDrawer(cart) {
    if (!cartItemsEl) return;

    if (cartDrawerCountEl) cartDrawerCountEl.textContent = '(' + cart.item_count + ')';

    if (!cart.items.length) {
      cartItemsEl.innerHTML = '';
      if (cartEmptyEl) cartEmptyEl.hidden = false;
      if (cartFooterEl) cartFooterEl.hidden = true;
      return;
    }

    if (cartEmptyEl) cartEmptyEl.hidden = true;
    if (cartFooterEl) cartFooterEl.hidden = false;
    if (cartSubtotalEl) cartSubtotalEl.textContent = moneyFormat(cart.total_price);

    cartItemsEl.innerHTML = cart.items
      .map(function (item, index) {
        var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_180x$1$2') : '';
        var variant = item.variant_title ? '<div class="cart-drawer-item__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
        return (
          '<li class="cart-drawer-item" data-cart-line="' + (index + 1) + '">' +
            (img ? '<img class="cart-drawer-item__image" src="' + img + '" alt="' + escapeHtml(item.title) + '" width="72" height="90" loading="lazy">' : '<div class="cart-drawer-item__image"></div>') +
            '<div class="cart-drawer-item__info">' +
              '<div class="cart-drawer-item__top">' +
                '<a class="cart-drawer-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
                '<button type="button" class="cart-drawer-item__remove" data-cart-remove aria-label="Remove ' + escapeHtml(item.product_title) + '">' +
                  '<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.4"/></svg>' +
                '</button>' +
              '</div>' +
              variant +
              '<div class="cart-drawer-item__bottom">' +
                '<div class="cart-drawer-item__qty">' +
                  '<button type="button" class="cart-drawer-item__qty-btn" data-cart-qty-minus aria-label="Decrease quantity">−</button>' +
                  '<span class="cart-drawer-item__qty-val">' + item.quantity + '</span>' +
                  '<button type="button" class="cart-drawer-item__qty-btn" data-cart-qty-plus aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<span class="cart-drawer-item__price">' + moneyFormat(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
          '</li>'
        );
      })
      .join('');
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        syncCartBadges(cart);
      })
      .catch(function () {});
  }

  function changeLine(line, quantity, rowEl) {
    if (rowEl) rowEl.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        syncCartBadges(cart);
      })
      .catch(function () {
        if (rowEl) rowEl.classList.remove('is-updating');
      });
  }

  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('[data-cart-line]');
      if (!row) return;
      var line = parseInt(row.getAttribute('data-cart-line'), 10);
      var qtyEl = row.querySelector('.cart-drawer-item__qty-val');
      var current = parseInt(qtyEl.textContent, 10);

      if (e.target.closest('[data-cart-qty-plus]')) {
        changeLine(line, current + 1, row);
      } else if (e.target.closest('[data-cart-qty-minus]')) {
        changeLine(line, Math.max(0, current - 1), row);
      } else if (e.target.closest('[data-cart-remove]')) {
        changeLine(line, 0, row);
      }
    });
  }

  /* ---------------- Cart badge sync (header icon + mobile drawer) ---------------- */
  function syncCartBadges(cart) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (badge) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(syncCartBadges)
      .catch(function () {});
  }

  // Refresh cart count whenever the theme dispatches a cart update,
  // and once on load in case the page was served from cache.
  document.addEventListener('cart:updated', updateCartCount);
  document.addEventListener('DOMContentLoaded', updateCartCount);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) updateCartCount();
  });

  // Expose a small API so product-page "Add to cart" forms elsewhere in the
  // theme can open/refresh this drawer, e.g.:
  //   window.SiteCart.open();  window.SiteCart.refresh();
  window.SiteCart = {
    open: openCartDrawer,
    close: closeCartDrawer,
    refresh: refreshCartDrawer
  };
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-herotwo"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-scroll-prompt]');
    if (!btn) return;

    // Prevent this click from also triggering a parent <a> banner link.
    e.preventDefault();
    e.stopPropagation();

    var banner = btn.closest('.image-banner');
    var next = banner ? banner.nextElementSibling : null;

    if (next) {
      next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollBy({ top: window.innerHeight * 0.9, behavior: 'smooth' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
